document.addEventListener('alpine:init', () => {
  Alpine.data('scrollBar', () => ({
    visible: true,
    lastScrollY: 0,
    buttonTop: 0,

    init() {
      const btn = document.querySelector('.product-form__submit');
      if (!btn) return;

      this.buttonTop = btn.getBoundingClientRect().top + window.scrollY;

      const observer = new MutationObserver(() => {
         const breadButton = document.querySelector('.bread-messaging .bread-btn-class a');

           try {
              const newLink = breadButton.cloneNode(true);
              newLink.href = "/pages/easy-pay-monthly-payment-plan-application";
              document.querySelector('.product-bar__bread-pay').innerHTML = '';
              document.querySelector('.product-bar__bread-pay').appendChild(newLink);
           } catch(error) {
             console.error('Error handling bread pay messaging click:', error);
           }

          //  observer.disconnect();
       });

       const breadPayMessaging = document.querySelector('.bread-messaging');

       observer.observe(breadPayMessaging, {
         childList: true,
         subtree: true
       });  
    }
  }));
});